import { Api, BuildVersion, ENCRYPT_STORAGE } from "../../config/config";
import { dto_selected_merchant_or_product } from "../../classes/dto-selected-merchant-or-product";
import { dto_MobileAppCategory } from "../../classes/dto-mobile-app-category";
import { dto_Customer } from "../../classes/dto-customer";
import { dto_Merchant } from "../../classes/dto-merchant";
import { dto_common } from "../../classes/dto-common";
import { postMethod, triggerApiRecoveryRedirect } from "../post";
import { ENTRY_MODE, MID } from "../../database/store-names";

const INVALID_QR_MERCHANT_MESSAGES = new Set([
  "Merchant data mapped",
  "Merchant data not mapped",
]);
const INVALID_QR_MERCHANT_MESSAGE = "Merchant data not mapped";

const getNumericMid = (...midCandidates) => {
  for (const candidate of midCandidates) {
    const resolvedMid = Number(candidate);
    if (Number.isFinite(resolvedMid) && resolvedMid > 0) {
      return resolvedMid;
    }
  }

  return 0;
};

const ensureValidProductListResponse = async (data, retryRequest) => {
  let parsedResponse = data;

  if (typeof data === "string") {
    const trimmedResponse = data.trim();

    if (INVALID_QR_MERCHANT_MESSAGES.has(trimmedResponse)) {
      const apiError = new Error(trimmedResponse || INVALID_QR_MERCHANT_MESSAGE);
      apiError.isInvalidQrMerchant = true;
      throw apiError;
    }

    try {
      parsedResponse = JSON.parse(data);
    } catch (_error) {
      await triggerApiRecoveryRedirect(
        new Error("Invalid product list response."),
        retryRequest,
      );
    }
  }

  if (!Array.isArray(parsedResponse)) {
    const apiError = new Error(
      parsedResponse?.Message || "Invalid product list response.",
    );

    if (
      parsedResponse?.Result === "ERROR" &&
      parsedResponse?.Message === INVALID_QR_MERCHANT_MESSAGE
    ) {
      apiError.isInvalidQrMerchant = true;
      throw apiError;
    }

    if (parsedResponse?.Result === "ERROR") {
      apiError.isApiRecoveryRedirect = true;
      throw apiError;
    }

    await triggerApiRecoveryRedirect(apiError, retryRequest);
  }

  return typeof data === "string" ? data : JSON.stringify(parsedResponse);
};

export const api_LoadProductListToMobileAppForAnMID = async () => {
  let MACID = dto_MobileAppCategory.MACID;
  if (MACID === undefined || isNaN(Number(MACID))) {
    dto_MobileAppCategory.MACID = 0;
    MACID = 0;
  }

  if (
    dto_MobileAppCategory.ListType === undefined ||
    isNaN(Number(dto_MobileAppCategory.ListType))
  ) {
    dto_MobileAppCategory.ListType = 1;
  }

  var url = `${Api}/?ControllerName104=/ApiHome`;
  let CATID;

  if (
    dto_selected_merchant_or_product.MT.toUpperCase() === "GR" ||
    dto_common.CSP === "MK" ||
    dto_common.CSP === "DT"
  ) {
    CATID = dto_selected_merchant_or_product.CATID;
    if (CATID === undefined) {
      CATID = 0;
    }
  } else if (CATID === undefined) {
    CATID = 0;
  }

  const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
  const MIDD = ENCRYPT_STORAGE.getItem(MID);
  const SERVICENAME =
    entryMode === "QR"
      ? "LoadProductListToQRForMID"
      : "LoadProductListToMobileAppForAnMID";
  const resolvedMid = getNumericMid(
    entryMode === "QR" ? MIDD : undefined,
    dto_Merchant.MID,
    dto_selected_merchant_or_product.MID,
  );

  if (entryMode === "QR") {
    dto_Merchant.MID = resolvedMid;
  }

  const payload =
    '{"SERVICENAME":"' +
    SERVICENAME +
    '","MID":' +
    resolvedMid +
    ',"MACID":' +
    MACID +
    ',"VERSION":"' +
    BuildVersion +
    '","CSP":"' +
    dto_common.CSP +
    '","COUNTRYCODE":"' +
    dto_common.NatvieCountry +
    '","COORDINATES":"' +
    dto_common.CurrentCordinate +
    '","NIC":"' +
    dto_Customer.NIC +
    '","CSID":' +
    dto_Customer.CSID +
    ',"CATID":' +
    CATID +
    ',"TYPE":' +
    dto_MobileAppCategory.ListType +
    ',"UITYPE":"' +
    dto_selected_merchant_or_product.MobileAppUIType +
    '"}';
  const runRequest = () => postMethod(url, payload);
  const data = await runRequest();
  return ensureValidProductListResponse(data, runRequest);
};

export const api_LoadProductListToQRForMID = async (MID) => {
  if (dto_MobileAppCategory.MACID === undefined) {
    dto_MobileAppCategory.MACID = 0;
  }

  var url = `${Api}/?ControllerName104=/ApiHome`;

  let SERVICENAME = "LoadProductListToQRForMID";
  let CATID = 0;
  if (
    dto_selected_merchant_or_product.MT.toUpperCase() === "GR" ||
    dto_selected_merchant_or_product.MT.toUpperCase() === "AF"
  ) {
    CATID = dto_selected_merchant_or_product.CATID;
    if (CATID === undefined) {
      CATID = 0;
    }
  }
  const payload =
    '{"SERVICENAME":"' +
    SERVICENAME +
    '","MID":' +
    MID +
    ',"MACID":' +
    dto_MobileAppCategory.MACID +
    ',"VERSION":"' +
    BuildVersion +
    '","CSP":"' +
    dto_common.CSP +
    '","COUNTRYCODE":"' +
    dto_common.NatvieCountry +
    '","COORDINATES":"' +
    dto_common.CurrentCordinate +
    '","NIC":"' +
    dto_Customer.NIC +
    '","CSID":' +
    dto_Customer.CSID +
    ',"CATID":' +
    CATID +
    ',"UITYPE":"' +
    dto_selected_merchant_or_product.MobileAppUIType +
    '"}';
  const runRequest = () => postMethod(url, payload);
  const data = await runRequest();
  return ensureValidProductListResponse(data, runRequest);
};
